const FILTERS_KEY = 'tugg_filters_v1';

const DEFAULTS = {
  position: 'all',
  team: 'all',
  searchTerm: '',
  sortColumn: 'OV',
  sortDirection: 'desc',
  playerTypeFilter: 'all',
  playerViewMode: 'cards',
  goalieViewMode: 'cards',
};

export function loadPersistedFilters() {
  try {
    const raw = localStorage.getItem(FILTERS_KEY);
    if (!raw) return { ...DEFAULTS };
    return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULTS };
  }
}

export function savePersistedFilters(filters) {
  try {
    localStorage.setItem(
      FILTERS_KEY,
      JSON.stringify({
        position: filters.position ?? DEFAULTS.position,
        team: filters.team ?? DEFAULTS.team,
        searchTerm: filters.searchTerm ?? DEFAULTS.searchTerm,
        sortColumn: filters.sortColumn ?? DEFAULTS.sortColumn,
        sortDirection: filters.sortDirection ?? DEFAULTS.sortDirection,
        playerTypeFilter: filters.playerTypeFilter ?? DEFAULTS.playerTypeFilter,
        playerViewMode: filters.playerViewMode ?? DEFAULTS.playerViewMode,
        goalieViewMode: filters.goalieViewMode ?? DEFAULTS.goalieViewMode,
      })
    );
  } catch {
    // localStorage unavailable
  }
}
